import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { SetAttrsStep } from '@atlaskit/adf-schema/steps';
import { AnalyticsListener } from '@atlaskit/analytics-next';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import ReactNodeView from '@atlaskit/editor-common/react-node-view';
import TaskItem from '../ui/Task';
import { useShowPlaceholder } from './hooks/use-show-placeholder';
var TaskItemWrapper = function TaskItemWrapper(_ref) {
  var localId = _ref.localId,
    forwardRef = _ref.forwardRef,
    isDone = _ref.isDone,
    onChange = _ref.onChange,
    providerFactory = _ref.providerFactory,
    isContentNodeEmpty = _ref.isContentNodeEmpty,
    api = _ref.api,
    getPos = _ref.getPos,
    editorView = _ref.editorView;
  var _useSharedPluginState = useSharedPluginState(api, ['taskDecision']),
    taskDecisionState = _useSharedPluginState.taskDecisionState;
  var isFocused = Boolean((taskDecisionState === null || taskDecisionState === void 0 ? void 0 : taskDecisionState.focusedTaskItemLocalId) === localId);
  var showPlaceholder = useShowPlaceholder({
    editorView: editorView,
    isContentNodeEmpty: isContentNodeEmpty,
    getPos: getPos,
    api: api
  });
  return /*#__PURE__*/React.createElement(TaskItem, {
    taskId: localId,
    contentRef: forwardRef,
    isDone: isDone,
    onChange: onChange,
    isFocused: isFocused,
    showPlaceholder: showPlaceholder,
    providers: providerFactory
  });
};
var Task = /*#__PURE__*/function (_ReactNodeView) {
  _inherits(Task, _ReactNodeView);
  var _super = _createSuper(Task);
  function Task() {
    var _this;
    _classCallCheck(this, Task);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (taskId, isChecked) {
      var tr = _this.view.state.tr;
      var nodePos = _this.getPos();
      if (typeof nodePos !== 'number') {
        return false;
      }

      // SetAttrsStep should be used to prevent task updates from being dropped when mapping task ticks
      // from a previous version of the document, such as a published page.
      tr.step(new SetAttrsStep(nodePos, {
        state: isChecked ? 'DONE' : 'TODO',
        localId: taskId
      }));
      tr.setMeta('scrollIntoView', false);
      _this.view.dispatch(tr);
    });
    /**
     * Dynamically generates analytics data relating to the parent list.
     *
     * Required to be dynamic, as list (in prosemirror model) may have
     * changed (e.g. item movements, or additional items in list).
     * This node view will have not rerendered for those changes, so
     * cannot render the position and listSize into the
     * AnalyticsContext at initial render time.
     */
    _defineProperty(_assertThisInitialized(_this), "addListAnalyticsData", function (event) {
      try {
        var nodePos = _this.getPos();
        if (typeof nodePos !== 'number') {
          return false;
        }
        var resolvedPos = _this.view.state.doc.resolve(nodePos);
        var position = resolvedPos.index();
        var listSize = resolvedPos.parent.childCount;
        var listLocalId = resolvedPos.parent.attrs.localId;
        event.update(function (payload) {
          var _payload$attributes = payload.attributes,
            attributes = _payload$attributes === void 0 ? {} : _payload$attributes,
            actionSubject = payload.actionSubject;
          if (actionSubject !== 'action') {
            // Not action related, ignore
            return payload;
          }
          return _objectSpread(_objectSpread({}, payload), {}, {
            attributes: _objectSpread(_objectSpread({}, attributes), {}, {
              position: position,
              listSize: listSize,
              listLocalId: listLocalId
            })
          });
        });
      } catch (e) {
        // This can occur if pos is NaN (seen it in some test cases)
        // Act defensively here, and lose some analytics data rather than
        // cause any user facing error.
      }
    });
    return _this;
  }
  _createClass(Task, [{
    key: "initWithAPI",
    value: function initWithAPI(api) {
      this.api = api;
      this.init();
      return this;
    }
  }, {
    key: "isContentEmpty",
    value: function isContentEmpty(node) {
      return node.content.childCount === 0;
    }
  }, {
    key: "createDomRef",
    value: function createDomRef() {
      var domRef = document.createElement('div');
      domRef.style.listStyleType = 'none';
      return domRef;
    }
  }, {
    key: "getContentDOM",
    value: function getContentDOM() {
      var dom = document.createElement('div');
      // setting a className prevents PM/Chrome mutation observer from
      // incorrectly deleting nodes
      dom.className = 'task-item';
      return {
        dom: dom
      };
    }
  }, {
    key: "render",
    value: function render(props, forwardRef) {
      var _this$node$attrs = this.node.attrs,
        localId = _this$node$attrs.localId,
        state = _this$node$attrs.state;
      var isContentNodeEmpty = this.isContentEmpty(this.node);
      return /*#__PURE__*/React.createElement(AnalyticsListener, {
        channel: "fabric-elements",
        onEvent: this.addListAnalyticsData
      }, /*#__PURE__*/React.createElement(TaskItemWrapper, {
        localId: localId,
        forwardRef: forwardRef,
        isDone: state === 'DONE',
        onChange: this.handleOnChange,
        isContentNodeEmpty: isContentNodeEmpty,
        providerFactory: props.providerFactory
        // The getPosHandler type is wrong, there is no `boolean` in the real implementation
        // @ts-expect-error 2322: Type 'getPosHandler' is not assignable to type '() => number | undefined'.
        ,
        getPos: this.getPos,
        editorView: this.view,
        api: this.api
      }));
    }
  }, {
    key: "viewShouldUpdate",
    value: function viewShouldUpdate(nextNode) {
      /**
       * To ensure the placeholder is correctly toggled we need to allow react to re-render
       * on first character insertion.
       * Note: last character deletion is handled externally and automatically re-renders.
       */
      return this.isContentEmpty(this.node) && !!nextNode.content.childCount;
    }
  }, {
    key: "update",
    value: function update(node, decorations) {
      var _this2 = this;
      return _get(_getPrototypeOf(Task.prototype), "update", this).call(this, node, decorations, undefined, function (currentNode, newNode) {
        return (
          // Toggle the placeholder based on whether user input exists
          !_this2.isContentEmpty(newNode) && !!(currentNode.attrs.state === newNode.attrs.state)
        );
      });
    }
  }]);
  return Task;
}(ReactNodeView);
export function taskItemNodeViewFactory(portalProviderAPI, eventDispatcher, providerFactory, api) {
  return function (node, view, getPos) {
    var hasIntlContext = true;
    return new Task(node, view, getPos, portalProviderAPI, eventDispatcher, {
      providerFactory: providerFactory
    }, undefined, undefined, undefined, hasIntlContext).initWithAPI(api);
  };
}